import React from "react";
import styled from "styled-components";

import { Panel } from "@workboard/wobo-ui";

import Term from "./Term";
import { useTranslation } from "react-i18next";

const Section = styled("section")``;

const Groups = ({ className, groups }) => {
  const { t } = useTranslation();
  return (
    <Panel as={Section} className={className}>
      <Term
        title={t("Total Working Groups")}
        helperText={t("This is the number of custom teams (teams not part of the org chart).")}
      >
        {groups}
      </Term>
    </Panel>
  );
}

export default styled(Groups)``;
